module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_m_albino.09a1c353.png";